<template>
    <section id="ProfileReports" class="m-dashboardlist" v-if="searchResults.length">

        <h2>Research &amp; Reports</h2>

        <div class="items">
            <report-list-item v-for="searchResult in searchResults" :key="searchResult.Id" :result-item="searchResult" :hide-image="true"></report-list-item>
        </div>

        <div class="pagingInfo"></div>

        <div class="e-viewmore">
            <span>Showing {{resultsLoaded}} of {{resultCount}} research &amp; reports</span>

            <div class="btn btn-outline green" v-if="moreResultsAvailable" v-on:click="nextPage()">
                View more
            </div>
        </div>
    </section>
</template>

<script>
    import Axios from 'axios'
    import { concat } from 'lodash'
    import ReportListItem from '@/components/ReportSearch/report-list-item'

    export default {
        components: {
            ReportListItem
        },

        data() {
            return {
                loading: true,
                moreResultsAvailable: false,
                nextPageNum: 0,
                resultCount: 0,
                resultsLoaded: 0,
                searchResults: []
            }
        },

        created: function () {
            this.search(1, false)
        },

        methods: {
            search: function (page, moreResults) {
                var vm = this
                vm.loading = true

                const getSearchResults = function () {
                    return Axios.get('/umbraco/api/MemberProfileApi/GetReports', { params: { currentPageId: currentPageId, page: page } })
                }

                Axios.all([getSearchResults()])
                    .then(Axios.spread(function (response) {

                        if (!moreResults) {
                            vm.searchResults = response.data.SearchResults
                            vm.resultCount = response.data.ResultCount
                            vm.resultsLoaded = response.data.ResultsLoaded
                            vm.moreResultsAvailable = response.data.ResultsLoaded < response.data.ResultCount
                            vm.nextPageNum = page + 1
                        }
                        else {
                            vm.searchResults = concat(vm.searchResults, response.data.SearchResults)
                            vm.resultsLoaded = vm.resultsLoaded + response.data.SearchResults.length
                            vm.nextPageNum = vm.nextPageNum + 1
                            vm.moreResultsAvailable = vm.resultsLoaded < response.data.ResultCount
                        }
                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            },

            nextPage: function () {

                var vm = this
                this.search(vm.nextPageNum, true)
            }
        }
    }
</script>
